/**
 * Руки A/B-теста масштаба поля (MADR 0036) — только отрисовка, бой и журнал волны те же.
 *
 * - `a` — как было: камера боя `BATTLE_ZOOM`.
 * - `b` — поле дальше в 1,4 раза, всё мельче в 1,4 раза.
 *
 * `base` и `zombie` разводят размеры базы и зомби относительно камеры; если база крупнее камеры, мир вокруг штаба на экране
 * растягивается (`RadialWarp`), чтобы штаб не наезжал на платформы. Так была устроена рука Г первого теста (MADR 0035):
 * камера ×0,8, база ×1,25, зомби ×0,75. В тесте сейчас её нет.
 */
import type { FieldScale } from "@newfungame/contracts";
import { FIXED_ONE, type Vec2 } from "@newfungame/contracts";
import type { RadialWarp } from "./iso";

export interface FieldLook {
  /** Множитель камеры боя. */
  zoom: number;
  /** Размер штаба, платформ и героев относительно камеры. */
  base: number;
  /** Размер зомби и боссов относительно камеры. */
  zombie: number;
}

export const FIELD_LOOKS: Record<FieldScale, FieldLook> = {
  a: { zoom: 1, base: 1, zombie: 1 },
  b: { zoom: 1 / 1.4, base: 1, zombie: 1 },
};

/** Растяжение доходит до ближних платформ с героями (дальняя — 2,6 клетки от штаба) и сходит на нет к краям поля. */
const WARP_R0 = 3 * FIXED_ONE;
const WARP_R1 = 7 * FIXED_ONE;

/** Растяжение вокруг штаба для руки; `undefined` — не нужно. */
export function lookWarp(look: FieldLook, hq: Vec2): RadialWarp | undefined {
  if (look.base === 1) return undefined;
  return { cx: hq.x, cy: hq.y, k: look.base, r0: WARP_R0, r1: WARP_R1 };
}
